const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentSocialMediaGrid extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}
		this.initialized = true;

	}

}

customElements.define('component-social-media-grid', ComponentSocialMediaGrid, {extends: 'div'});